export default __webpack_public_path__ + "static/media/home-fill.de9b70fc.svg";